module.exports = __webpack_public_path__ + "static/img/appointment01.593b484b.png";